export default {
  title: 'Security Materials Calculator',
  common: {
    reset: 'Reset',
    compute: 'Calculate',
    result: 'Calculation Result:',
    day: 'Day',
    hour: 'Hour',
    days: 'Days',
    hours: 'Hours',
    meter: 'm',
    feet: 'ft',
    mm:'MM',
    channel: 'ch',
    Box:'Box',
    pleaseEnter: 'Please enter',
    pleaseChoose: 'Please choose',
    resultNote: 'Calculation result is for reference only.',
    to: 'to',
    streamReference: 'Relation between Resolutions and Bit Rates (For Reference only)',
    resolution: 'Resolution',
    stream: 'Stream',
    yes:'Yes',
    no:'No',
    length:'Length',
    width:'Width',
    unit:'Unit'
  },
  lens: {
    common: 'Lens Calculation',
    focus: 'Focal Length',
    objectDistance: 'Object Distance',
    objectWidth: 'Object Width',
    sensorWidth: 'Sensor Dimension',
    lensFocus: 'Focal Length',
  },
  capacity: {
    common: 'Capacity Calculation',
    videoSize: 'Video Size',
    recordTime: 'Record Time',
    diskArray: 'Disk Array',
    custom: 'Custom',
    bitRate: 'Bit Rate',
    customRate: 'Custom Bit Rate',
    cameraNum: 'Cameras',
    storageDay: 'Storage Days',
    totalDiskSize: 'Total Disk Capacity',
    driver: 'Device Drive',
    raid: 'RAID',
    diskSize: 'Disk Capacity',
    availableSize: 'Valid Capacity',
    driverList: {
      8: '8-HDD',
      16: '16-HDD',
      24: '24-HDD',
      36: '36-HDD',
      48: '48-HDD'
    },
    resultSeperator1: ' ', //录像时间计算结果中数值和单位之前的间隔
    resultSeperator2: ', '//录像时间计算结果中天和小时之间的间隔
  },
  ip: {
    common: 'IP Calculation',
    hostIp: 'Host IP',
    maskBits: 'Mask Bits',
    networkAddr: 'Current Network',
    netmaskAddr: 'Subnet Mask',
    hostRange: 'Host Range',
    host: 'Host',
    mask: 'Mask',
    subnet: 'Subnet',
    broadcastAddr: 'Broadcast Address',
    ipPlaceholder: '— — —'
  },
  NVRModel: {
    common: 'NVR Model'
  },
  twistedPair: {
    common: 'Twisted Pair',
    Locations:'Locations',
    cableSpecifications:'Cable Specifications',
    cableList: {
      100: '100 m/box',
      305: '305 m/box',
    },
    result: {
      note: 'Required number of cables with the specification of {field}: '
    },
    placeholder:'Please enter'
  },
  splicingScreen: {
    common: 'Splicing Screen'
  },
  UPS: {
    common: 'UPS'
  },
  cameraPowerSupply: {
    common: 'Camera Power Supply'
  },
  cameraFocalLength: {
    common: 'Camera Focal Length'
  },
  cableTrayCapacity: {
    common: 'Cable Tray Capacity'
  },
  RVVWire: {
    common: 'RVV Wire'
  },
  bandwidthCalculator:{
    common:'Bandwidth Calculator',
    numberOfDevices:'Number Of Devices',
    encodingType:'Encoding Type',
    recommendedBitRate:'Recommended Bit Rate',
    result:'Required Bandwidth:',
    deviceType:'Device Type'
  },
  switchAccessCalculator:{
    common:'Switch Access Calculator',
    numberOfConnectedIPCs:'Connected IPCs',
    numberOfSwitches:'Connected Switches',
    operatingEnvironment:'Operating Environment',
    environment:{
      indoor:'Indoor',
      outdoor:'Outdoor'
    },
    PoE:'PoE',
    opticalPort:'Optical Port',
    switchType:'Switch Type',
    switchModel:'Switch Model',
    switchTypes:{
      coreSwitch:'Core Switch',
      100:'100 Mbps Switch',
      1000:'1,000 Mbps Switch'
    },
    IPCBitRate:'IPC Bit Rate',
    numberofIPCs:'Number of IPCs',
    ePOE:'ePoE',
    longDistanceTransmission:'Long-distance Transmission',
    resultNote: 'Notice: Please calculate required quantity of switch based on the displayed access channel by yourself.',
    result: {
      IPC: 'Number of {field} IPCs that can be connected:',
      switch: 'Recommended Switch Model and Channels:',
      core:"Number of IPCs that can be connected:"
    }
  },
  intelligentWirelessSolution:{
    common:'Wireless Solution',
    bridge:'Bridge',
    location:'Location',
    outdoorBridge:'Outdoor Bridge',
    elevatorBridge:'Elevator Bridge',
    AP:'AP/Router',
    outdoorAp:'Outdoor AP',
    indoorAp:'Indoor AP',
    rooms:'Number of Rooms',
    square:'Square',
    hall:'Hall/Dining Room',
    room:'Room',
    numberOfBridges:'Number of Bridges',
    pointToMultipoint:'Point-to-Multipoint',
    pointToPoint:'Point-to-Point',
    inputNumOfIPC:'Please enter the number of IPCs.',
    inputNumOfRooms:'Please enter the number of rooms.',
    inputLengthOfRooms:'Please enter the length of rooms.',
    inputWidthOfRooms:'Please enter the width of rooms.',
    inputWidthOfSquare:'Please enter the width of square.',
    inputLengthOfSquare:'Please enter the length of square.',
    roomLength:'The length of room',
    roomWidth:'The width of room',
    squareWidth:'The width of square',
    squareLength:'The length of square',
    IPCbite:'IPC Bit Rate',
    IPCnum:'Number of IPCs',
    transmissionDistance:'Transmission Distance',
    frequencyBand:'Frequency Band',
    deviceType:'Product Type',
    deviceModel:"Product Model",
    deviceTotal:"Total Devices",
    deviceList:"Product List",
    AccessController:"Wireless Access Controller",
    solution:'Solution',
    netBridgeClient:'Client',
    netBridgeStation:'Server',
    matchingType:'Matching Type',
    resultTips:'Tips: Please select one solution from the list.',
    resultTips2:'Tips: Each room need 1 AP and 1 router. Please select one model for each type from the list.',
    resultTips3:'This result only corresponds to the entered data. In case of conflict with the actual situation, the actual situation shall prevail.',
    resultTips4:'If you encounter problems during procurement, installation and operation, please contact your local Dahua personnel for support.'
  },
  error: {
    emptyCameraNum: 'Please enter the number of cameras.',
    emptyStorageDay: 'Please enter storage days.',
    emptyTotalDiskSize: 'Please enter total disk capacity.',
    emptyCustomRate: 'Please enter custom bit rate.',
    emptyIP: 'Please enter host IP address.',
    illegalIP: 'Please enter valid host IP address.',
    emptyMask: 'Please enter mask bits.',
    emptyObjectDistance: 'Please enter object distance.',
    emptyDeviceNum: 'Please enter the number of devices.',
    emptyObjectWidth: 'Please enter object width.',
    emptySwitchModel: 'Please select switch model.',
    emptyLmax:'Please enter the distance between the device and the weak electricity well',
    emptyPoint:'Please enter the number of location.',
    numberofIPCs:'Please enter the number of IPC.',
    cannotBeZero: '{field} cannot be zero.',
    noType:'No recommended model.'
  },
  info: {
    comingSoon: 'More tools coming soon...'
  }
}



// WEBPACK FOOTER //
// ./src/lang/en.js